module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/giftcard/bg1-59c9bc387787f940695e8cdd34f71d69.jpg";